<template>
	<div class="grid-flex-container">
		<grid-history-toolbar
			:quickFilter="quickFilter"
			:advancedFilter="advancedFilter"
			:visibleColumns="visibleColumns"
			:showUsers="true"
			@quickFilterChanged="onQuickFilterChanged"
			@advancedFilterChanged="onAdvancedFilterChanged"
			@dateChanged="onDateChanged"
			@userChanged="onUserChanged"
			@export="onExport"
			class="mb-4"
		/>
		<div class="generic-grid-container">
			<v-data-table
				dense
				fixed-header
				v-if="headers"
				:items="recordsData"
				:loading="loadingData"
				:headers="headers"
				:server-items-length="historyDataCount"
				:footer-props="{
					itemsPerPageOptions: [10, 15, 20, 25, 30, 50, 100],
					showFirstLastPage: true,
					showCurrentPage: true,
					pagination: {
						page: options.page,
						itemsPerPage: options.itemsPerPage,
						pageStart,
						pageStop,
						pageCount,
						itemsLength: historyDataCount,
					},
				}"
				:options.sync="options"
				:hide-default-footer="loadingData"
			>
				<template v-slot:item.NavigationButton="{ item }">
					<td class="fixed-col">
						<v-btn
							fab
							small
							icon
							elevation="1"
							class="action-btn"
							@click="openItemHistory(item.RecordId)"
						>
							<v-icon color="info" small>mdi-history</v-icon>
						</v-btn>
					</td>
				</template>

				<template v-slot:item.ActionDate="{ item }">{{
					getDateTimeFormat(item.RecordActionDate)
				}}</template>
				<template v-slot:item.IrisUserId="{ item }">{{
					getUserDisplay(item.IrisUserId)
				}}</template>
				<template v-slot:item.IrisProcess="{ item }">{{
					getIrisProcessDisplayFormat(item.IrisProcess)
				}}</template>
				<template v-slot:item.Deleted="{ item }">
					<span :class="hasChanges(item, 'Deleted')">
						<v-icon
							color="error"
							v-if="getGridColumnValue(item, 'Deleted')"
							>mdi-close-circle</v-icon
						>
					</span>
				</template>
				<template
					v-for="column in visibleColumns"
					v-slot:[`item.${column.FieldName}`]="{ item }"
				>
					<template
						v-if="
							column.DataField.DataType === fieldDataTypes.FILE &&
							item[column.FieldName + '_FileName']
						"
					>
						<span
							:key="column.FieldName"
							:class="hasChanges(item, column.FieldName)"
						>
							<v-icon class="mr-2" color="primary"
								>mdi-file-outline</v-icon
							>
							{{
								getGridColumnValue(
									item,
									column.FieldName + '_FileName'
								)
							}}
						</span>
					</template>
					<template
						v-else-if="
							column.DataField.DataType ===
								fieldDataTypes.DATETIME ||
							column.DataField.DataType ===
								fieldDataTypes.AUTOGENERATED_DATETIME
						"
					>
						<span
							:key="column.FieldName"
							:class="hasChanges(item, column.FieldName)"
						>
							{{
								getDateTimeFormat(
									getGridColumnValue(item, column.FieldName)
								)
							}}
						</span>
					</template>
					<template
						v-else-if="
							column.DataField.DataType === fieldDataTypes.DATE
						"
					>
						<span
							:key="column.FieldName"
							:class="hasChanges(item, column.FieldName)"
						>
							{{
								getDateFormat(
									getGridColumnValue(item, column.FieldName)
								)
							}}
						</span>
					</template>
					<template v-else>
						<span
							:key="column.FieldName"
							:class="hasChanges(item, column.FieldName)"
						>
							{{ getGridColumnValue(item, column.FieldName) }}
						</span>
					</template>
				</template>
			</v-data-table>
		</div>
	</div>
</template>
<script>
import GridHistoryToolbar from './GridHistoryToolbar.vue';
import { mapGetters } from 'vuex';
import { GridsHistoryActions } from '../../../store/actions';
import { GridsGetters, GridsHistoryGetters } from '../../../store/getters';
import { gridViewTypes } from '../../../enums/gridViewTypes';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';
import { FieldDataTypes } from '../../../enums/fieldDataTypes';
import { getIrisProcessDisplayFormat } from '../../../enums/processEnum';
export default {
	name: 'GridHistoryPerUser',
	components: {
		GridHistoryToolbar,
	},
	mixins: [projectSettingsMixin],
	data() {
		return {
			expanded: [],
			quickFilter: { FieldId: null, Value: '' },
			advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
			startDate: null,
			endDate: null,
			userIds: [],
			options: {
				itemsPerPage: 50,
				page: 1,
			},
		};
	},
	watch: {
		'options.itemsPerPage'() {
			this.loadData();
		},
		'options.page'() {
			this.loadData();
		},
	},
	computed: {
		fieldDataTypes() {
			return FieldDataTypes;
		},
		...mapGetters({
			entities: [GridsGetters.GET_ENTITIES],
			gridViews: [GridsGetters.GET_GRID_VIEWS],
			records: [GridsHistoryGetters.GRID_RECORDS],
			historyData: [GridsHistoryGetters.GRID_DATA],
			historyDataCount: [GridsHistoryGetters.GRID_DATA_COUNT],
			loadingData: [GridsHistoryGetters.GRID_LOADING],
			irisUsersMetadata: [GridsHistoryGetters.IRIS_USER_METADATA],
			mergeConditionsFields: [
				GridsHistoryGetters.MERGE_CONDITINOS_FIELDS,
			],
		}),

		recordsData() {
			if (this.loadingData) return [];
			return this.records;
		},

		selectedEntityName() {
			return this.$route.params.pageName;
		},
		selectedEntity() {
			if (!this.entities) return null;
			if (this.entities.length <= 0) return null;
			if (!this.selectedEntityName) return null;
			return this.entities.find((x) => x.Name == this.selectedEntityName);
		},
		selectedGridView() {
			if (!this.selectedEntity) return null;
			if (!this.selectedEntity.Id) return null;
			if (!this.gridViews) return null;
			return this.gridViews.find(
				(x) =>
					x.EntityId == this.selectedEntity.Id &&
					this.UserId == null &&
					gridViewTypes.Grids
			);
		},

		visibleColumns() {
			if (!this.selectedGridView) return [];
			let columns = JSON.parse(
				JSON.stringify(this.selectedGridView.Columns)
			);
			return columns.sort((a, b) => a.Order - b.Order);
		},

		headers() {
			if (!this.visibleColumns) return null;
			let result = [
				{
					text: 'Action Date',
					value: 'ActionDate',
					groupable: false,
					sortable: false,
					align: 'start',
				},
				{
					text: 'Iris User',
					value: 'IrisUserId',
					groupable: false,
					sortable: false,
					align: 'start',
				},
				{
					text: 'Process',
					value: 'IrisProcess',
					groupable: false,
					sortable: false,
					align: 'start',
				},
				{
					text: 'Deleted',
					value: 'Deleted',
					groupable: false,
					sortable: false,
					align: 'start',
				},
				...this.visibleColumns.map((x) => ({
					text: x.Label,
					value: x.FieldName,
					groupable: false,
					sortable: false,
					align: 'start',
				})),
			];

			result.push({
				text: '',
				value: 'NavigationButton',
				groupable: false,
				sortable: false,
				align: 'start',
			});
			return result;
		},

		totalCount() {
			return this.historyDataCount;
		},
		pageStart() {
			return this.options.itemsPerPage * (this.options.page - 1);
		},
		pageStop() {
			return this.options.itemsPerPage * this.options.page;
		},
		pageCount() {
			if (!this.options.itemsPerPage) return 0;
			if (!this.totalCount) return 0;
			let quotient = Math.floor(
				this.totalCount / this.options.itemsPerPage
			);
			let remainder = this.totalCount % this.options.itemsPerPage;
			if (remainder === 0) return quotient;
			return quotient + 1;
		},
	},

	mounted() {
		if (this.selectedEntity && this.selectedEntity.Id) {
			this.$store
				.dispatch(
					GridsHistoryActions.LOAD_MERGE_CONDITIONS,
					this.selectedEntity.Id
				)
				.then(() => {
					this.loadData();
				});
		}
	},
	destroyed() {
		this.$store.dispatch(GridsHistoryActions.CLEAR);
	},
	methods: {
		onExport(options) {
			let payload = {
				EntityId: this.selectedEntity.Id,
				RecordId: null,
				UsersId: this.userIds,
				StartDate: this.startDate,
				EndDate: this.endDate,
				Page: this.options.page,
				RowsPerPage: this.options.itemsPerPage,
				QuickFilter: this.quickFilter,
				AdvancedFilter: this.advancedFilter,
				IncludeAllRecords: false,
				TimeZone: options.timeZone,
			};
			if (options && options.allData) {
				payload.Page = 0;
				payload.RowsPerPage = 0;
				payload.IncludeAllRecords = true;
			}
			this.$store.dispatch(GridsHistoryActions.EXPORT_PERUSER, {
				payload: payload,
			});
		},

		loadData() {
			let payload = {
				EntityId: this.selectedEntity.Id,
				RecordId: null,
				UsersId: this.userIds,
				StartDate: this.startDate,
				EndDate: this.endDate,
				Page: this.options.page,
				RowsPerPage: this.options.itemsPerPage,
				QuickFilter: this.quickFilter,
				AdvancedFilter: this.advancedFilter,
			};
			this.$store.dispatch(
				GridsHistoryActions.LOAD_USER_GRID_DATA,
				payload
			);
		},
		getHistoryData(item) {
			return this.historyData.filter(
				(x) =>
					x.Id == item.RecordId &&
					(x.RowNumber == item.RecordRowNumber ||
						x.RowNumber == item.RecordRowNumber + 1)
			);
		},

		getGridColumnValue(item, fieldName) {
			let data = this.getHistoryData(item).sort(
				(a, b) => a.RowNumber - b.RowNumber
			);
			if (data && data.length >= 1) {
				return data[0][fieldName];
			}
			return null;
		},

		hasChanges(item, column) {
			let historyData = this.getHistoryData(item).sort(
				(a, b) => a.RowNumber - b.RowNumber
			);
			if (historyData.length > 1) {
				let newColumn = historyData[0][column];
				let oldColumn = historyData[1][column];
				if (newColumn !== oldColumn) {
					return 'changed pa-2';
				}
			}
			return 'pa-2';
		},

		getUserDisplay(userId) {
			var user = this.irisUsersMetadata.find((x) => x.Id == userId);
			if (user) {
				return user.IrisUserFormat;
			}
			return userId;
		},
		onQuickFilterChanged(value) {
			this.quickFilter = value;
			this.loadData();
		},
		onAdvancedFilterChanged(value) {
			this.advancedFilter = value;
			this.loadData();
		},
		onUserChanged(value) {
			this.userIds = value;
			this.loadData();
		},
		onDateChanged(value) {
			this.startDate = value[0];
			this.endDate = value[1];
			this.loadData();
		},
		getIrisProcessDisplayFormat(value) {
			return getIrisProcessDisplayFormat(value);
		},

		openItemHistory(id) {
			this.$router.push({
				name: 'DatasetsRecordHistory',
				params: {
					pageName: this.selectedGridView.Entity.Name,
					assetId: id,
				},
			});
		},
	},
};
</script>
<style lang="css">
.v-data-table__empty-wrapper {
	display: none;
}

.v-data-table__expanded__row {
	background: #eeeeee;
}

.v-data-table
	> .v-data-table__wrapper
	tbody
	tr.v-data-table__expanded__content {
	box-shadow: none;
}

span.changed {
	background-color: #ffc00030;
}

.recordHistoryGrid .v-data-table__wrapper {
	overflow-y: hidden;
}
</style>

<style lang="scss">
.grid-flex-container {
	.v-card__text {
		overflow-y: scroll;

		.changed {
			background-color: #ffc00030;
		}

		.grid-field {
			padding: 0 1.5rem;
			margin: 1.5rem 0;
		}

		.v-input.v-input--is-readonly {
			padding: 0 1.5rem;
			margin: 1.5rem 0;
		}
	}
}
</style>
